import React, {PureComponent} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import Menu from './Menu';
import TranslatedText from '../../atoms/TranslatedText';
import Rotation from '../../atoms/Rotation';
import videoBg from './cuts-glare-video.mp4';
import videoPoster from './cuts-glare-video-poster.jpg';
import axisImages from './axis';
import i18n from '../../locales/i18n';

import './CutsGlare.css';
import './CutsGlareAxisOfPolarization.css';
import Video from '../../atoms/Video';

export default class CutsGlareAxisOfPolarization extends PureComponent {
    state = {
        frame: 0,
    };

    imageR = React.createRef();

    lastFirstFrame = 0;
    currentFrame = 0;

    componentDidMount() {
        // preload images
        axisImages[i18n.language].forEach(img => {
            const image = new Image();
            image.src = img;
        });
        ReactGA.pageview(
            `${i18n.language}/HDPolarized/CutsGlare/AxisOfPolarization`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/HDPolarized/CutsGlare/AxisOfPolarization`
        );
    }

    onPanEnd = () => (this.lastFirstFrame = this.currentFrame);

    onPan = e => {
        const {deltaX} = e;

        this.currentFrame =
            (axisImages[i18n.language].length +
                this.lastFirstFrame +
                Math.round(deltaX / 3)) %
            axisImages[i18n.language].length;

        this.imageR.current.updateImage(
            axisImages[i18n.language][this.currentFrame]
        );
    };

    render() {
        const history = this.props.history;

        return (
            <article>
                <Hammer
                    direction="DIRECTION_HORIZONTAL"
                    onPanEnd={this.onPanEnd}
                    onPan={this.onPan}>
                    <div className="CutsGlare-container">
                        <h3 className="top-title">
                            <TranslatedText tag="hdpolarized.cuts_glare.axis_of_polarization.title" />
                        </h3>
                        <h4 className="top-subtitle">
                            <TranslatedText tag="hdpolarized.cuts_glare.axis_of_polarization.subTitle" />
                        </h4>
                        <Rotation
                            ref={this.imageR}
                            label="hdpolarized.cuts_glare.axis_of_polarization.scroll"
                            img={axisImages[i18n.language][this.state.frame]}
                        />
                    </div>
                </Hammer>
                <Menu active="axis-of-polarization" history={history} />
                <Video
                    className="CutsGlare-video CutsGlare-video--axis"
                    src={videoBg}
                    poster="data:image/gif,AAAA"
                    style={{backgroundImage: `url(${videoPoster})`}}
                    autoPlay
                    playsInline
                    muted
                    loop
                />
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/hdpolarized/CutsGlareAxisOfPolarization.js